import {
  AnalysisTemplateGroup,
  AnalysisTemplateGroupCreateExtras,
  AnalysisTemplateGroupMetadata,
} from 'notebook/notes/groups/analysis-template/AnalysisTemplateGroupConstants';
import GenericNoteLinkedGroupAdapter from 'notebook/notes/groups/GenericNoteLinkedGroupAdapter';
import {GroupActionFunctions} from 'notebook/notes/groups/NoteLinkedGroupConstants';
import {NotePart} from 'notebook/util/NoteUtilConstants';
import {Schema} from 'schemas/SchemaConstants';

export class AnalysisTemplateGroupNoteLinkedGroupAdapter extends GenericNoteLinkedGroupAdapter<
  AnalysisTemplateGroupMetadata,
  AnalysisTemplateGroupCreateExtras
> {
  getDisplayName(_group: AnalysisTemplateGroup): string {
    return 'Analysis';
  }

  // The embed is a read-only snapshot: the backend blocks clone and scrubs the group's
  // identifiers, so the group opts out of copy/paste entirely.
  override supportsCopyPaste(): boolean {
    return false;
  }

  // The analysis and its group are created server-side by the V3 content-input handler; the group
  // carries no contained note parts on the client.
  createNoteParts(): Array<Omit<NotePart, 'cid'>> {
    return [];
  }

  getGroupSchemas(_group: AnalysisTemplateGroup): Array<Schema> {
    return [];
  }

  // Read-only embed: no refresh/submit/resync/clone controls.
  override getActionFunctions(): GroupActionFunctions<
    AnalysisTemplateGroupMetadata,
    AnalysisTemplateGroupCreateExtras
  > {
    return {primary: undefined, secondary: [], overflow: [], footer: []};
  }
}
